import { MaybeNull } from "types";

import { getResData, httpClient } from "utils";

export const COLLECTORS_API_PATHS = {
  BASE_COLLECTOR_PATH: "/collector",
  COLLECTOR: (collectorId: number) => `/collector/${collectorId}`,
  COLLECTORS_BY_SITE: (siteId: number) => `/collector/site/${siteId}`,
  CREATE_COLLECTOR: `/collector`,
  DELETE_COLLECTOR: (collectorId: number) => `/collector/${collectorId}`,
  UPDATE_COLLECTOR: (collectorId: number) => `/collector/${collectorId}`,
  COLLECTOR_ALL: "/collector/all",
  DEACTIVATED_COLLECTORS: (siteId: number) =>
    `/collector/site/${siteId}/de-activated`,
  UNIT_COST_BY_COLLECTOR: (collectorId: number) => `/collector/unitcost/${collectorId}`
};

interface EmissionFactorDetails {
  collectorId: number;
  convertedEfValue: number;
  createDate: string | null;
  createdBy: string | null;
  defaultEfUnit: string;
  documentUploadDate: string | null;
  documentUploaded: boolean;
  downloadUrl: string | null;
  efUnit: string;
  efValue: number;
  endDate: string;
  fileName: string | null;
  id: number;
  lastEditedBy: string | null;
  providerName: string;
  renewableEnergy: number;
  s3Path: string | null;
  startDate: string;
  updateDate: string | null;
  utilityType: string;
}

export interface Collector {
  accountNumber: string;
  allowedDocuments: string[];
  consumptionUnit: string;
  country?: MaybeNull<string>;
  currency: string;
  disableDate?: string;
  emissionFactorDetails?: EmissionFactorDetails[];
  enabled?: boolean;
  endDate?: number | string | Date;
  estimate?: boolean;
  frequency: string;
  id: number;
  meterNumber?: string;
  notes?: string;
  providerName: MaybeNull<string>;
  recs?: boolean;
  siteId: number;
  siteName: string;
  startDate?: number | string | Date;
  utilityTypeId: number;
  utilityTypeName: string;
}

export type CollectorDTO = Omit<Collector, "siteId" | "utilityTypeId">;
export type CreateCollectorDTO = Omit<
  Collector,
  "siteName" | "utilityTypeName" | "id"
>;
export type UpdateCollectorDTO = Omit<
  Collector,
  "siteName" | "utilityTypeName"
>;

export const createCollector = (body: CreateCollectorDTO) =>
  httpClient.post(COLLECTORS_API_PATHS.CREATE_COLLECTOR, body);

export const getCollectorById = (collectorId: number): Promise<CollectorDTO> =>
  httpClient
    .get<CollectorDTO>(COLLECTORS_API_PATHS.COLLECTOR(collectorId))
    .then(getResData);

export const getCollectorsBySiteId = (
  siteId: number,
): Promise<CollectorDTO[]> =>
  httpClient
    .get<CollectorDTO[]>(COLLECTORS_API_PATHS.COLLECTORS_BY_SITE(siteId))
    .then(getResData);

export const getAllCollectors = (): Promise<CollectorDTO[]> =>
  httpClient
    .get<CollectorDTO[]>(COLLECTORS_API_PATHS.COLLECTOR_ALL)
    .then(getResData);

export const updateCollector = (data: UpdateCollectorDTO) => {
  const { id, ...body } = data;

  return httpClient.put(COLLECTORS_API_PATHS.UPDATE_COLLECTOR(id), body);
};

export const getDeActivatedCollectorsBySiteId = (
  siteId: number,
): Promise<CollectorDTO[]> =>
  httpClient
    .get<CollectorDTO[]>(COLLECTORS_API_PATHS.DEACTIVATED_COLLECTORS(siteId))
    .then(getResData);

export const getUnitCostByCollectorId = (collectorId: number): Promise<any> =>
  httpClient
    .get<any>(COLLECTORS_API_PATHS.UNIT_COST_BY_COLLECTOR(collectorId))
    .then(getResData);
